module.exports = {"230706003":"新春社区","230706004":"新建社区","230706005":"育林社区","230706006":"繁荣社区","230706007":"保安社区","230706008":"文化社区","230706009":"胜利社区","230706010":"幸福社区","230706400":"解放经营所","230706401":"昆仑气林场","230706402":"开源河林场","230706403":"么河经营所","230706404":"冲锋经营所","230706405":"翠峦河经营所","230706406":"抚育河经营所","230706407":"尖山河经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230706.json
// module id = 745
// module chunks = 0